export default {
  // Dialog title
  dialogTitle: "Same IP Same Time Configuration",

  // Time range description
  timeRangeDescription:
    "Time Range Description: [Within 1 day] natural day, [Within 3 days] 3 days before and 3 days after, [Within 1 week] 7 days before and 7 days after from the date, [Within 1 month] 30 days before and 30 days after from the date, [Within 3 months] 90 days before and 90 days after from the date, [Within half a year] 180 days before and 180 days after from the date, [No limit] show all same IP users.",

  // Time options
  oneDay: "Within 1 Day",
  threeDays: "Within 3 Days",
  oneWeek: "Within 1 Week",
  oneMonth: "Within 1 Month",
  threeMonths: "Within 3 Months",
  halfYear: "Within Half Year",
  noLimit: "No Limit",

  // Buttons
  cancel: "Cancel",
  confirm: "Confirm",

  // Message prompts
  configSuccess: "Configuration successful",
};
